import * as React from "react";
import { IconProps } from "../types";

const BellOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M15.75 13.25C14.645 13.25 13.75 12.355 13.75 11.25V6.5C13.75 3.877 11.623 1.75 9 1.75C6.377 1.75 4.25 3.877 4.25 6.5V11.25C4.25 12.355 3.355 13.25 2.25 13.25H15.75Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.588 15.185C10.493 15.068 10.351 15 10.2 15H7.801C7.65 15 7.508 15.068 7.413 15.185C7.318 15.302 7.281 15.456 7.312 15.603C7.485 16.425 8.18 17 9.001 17C9.822 17 10.517 16.425 10.69 15.603C10.721 15.456 10.683 15.302 10.588 15.185Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default BellOutlineIcon;
